import Base from "./base";

export default class Vcreditos extends Base {
	makeExternalPayment(newStep) {
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(this.state.stake),
				currency: this.state.selectedCurrency,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(this.state.stake),
				claimsBonus: true,
				bonusId: bonusId,
				currency: this.state.selectedCurrency,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}
}
